"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tertiaryButtons = void 0;
exports.tertiaryButtons = [
    {
        props: { variant: 'tertiaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:focus': {
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:active': {
                    color: theme.palette.text.light,
                    backgroundColor: theme.palette.secondary.dark,
                },
                '&:disabled': {
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
    {
        props: { variant: 'tertiaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.light,
                '&:hover': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:focus': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:active': {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.neutrals.primary,
                },
                '&:disabled': {
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
];
